module.exports = __webpack_public_path__ + "static/img/1111.0d0a154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1111.jpg
// module id = BKcN
// module chunks = 1